const types = {
    SET_ACTIVE_AUCTION: 'SET_ACTIVE_AUCTION',
    GET_AUCTIONS: 'GET_AUCTIONS',
    FETCH_AUCTION_ITEMS: 'FETCH_AUCTION_ITEMS',
    FETCH_AUCTION_BIDS: 'FETCH_AUCTION_BIDS',
    FETCH_AUCTION_ITEMS_START: 'FETCH_AUCTION_ITEMS_START'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/auction/mutation-types.js